module.exports = __webpack_public_path__ + "img/2.59a6ba4a.jpg";